import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import EmployeesGroupDetailsEmployees from 'src/features/employees-groups/components/templates/employees-group-details/employees';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute(
  '/_layout/tenant/employees/groups/$groupToken/_layout/employees',
)({
  component: EmployeesGroupDetailsEmployees,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
